import Progressbar from "src/components/Progressbar";
import PanelLayout from "src/Layout/PanelLayout";
import Title from "src/components/Title";
import { useEffect, useState } from "react";
import Button from "src/components/Form/Button";
import Subheading from "src/components/Subheading";
import FormCheckbox from "src/components/Form/FormCheckbox";
import ZabanKhareji from "src/components/Form/ZabanKhareji";
import usePersistantState from "src/hooks/usePersistantState";

export default function JobAnalysisPage3({ handleStep, handleStepDown }) {
  /* زبان های خارجی */
  //const [tasks, setTasks] = usePersistantState("zabankharegi", ["انگلیسی"]);
  const [addTask, setAddTask] = useState(false);
  const [change, setChange] = useState(true);
  //   const addTask = () => {
  //     if (taskInputs.length < 14) {
  //       const newTasks = tasks;
  //       newTasks.push(tasks.length + 1);
  //       setTasks(newTasks);
  //       setChange(!change);
  //     }
  //   };

  const [zabanKhareji, setZabanKhareji] = usePersistantState("zabanha", {
    انگلیسی: {
      خواندن: {
        عدم‌نیاز: false,
        خیلی‌کم: false,
        کم: false,
        تاحدودی: false,
        زیاد: false,
        خیلی‌خوب: false,
      },
      نوشتن: {
        عدم‌نیاز: false,
        خیلی‌کم: false,
        کم: false,
        تاحدودی: false,
        زیاد: false,
        خیلی‌خوب: false,
      },
      ترجمه: {
        عدم‌نیاز: false,
        خیلی‌کم: false,
        کم: false,
        تاحدودی: false,
        زیاد: false,
        خیلی‌خوب: false,
      },
      مکالمه: {
        عدم‌نیاز: false,
        خیلی‌کم: false,
        کم: false,
        تاحدودی: false,
        زیاد: false,
        خیلی‌خوب: false,
      },
    },
  });
  console.log(zabanKhareji);
  const [selectedLanguage, setSelectedLanguage] = useState("");

  useEffect(() => {
    if (!selectedLanguage) return;
    const data = {
      ...zabanKhareji, [selectedLanguage]: {
        خواندن: {
          عدم‌نیاز: false,
          خیلی‌کم: false,
          کم: false,
          تاحدودی: false,
          زیاد: false,
          خیلی‌خوب: false,
        },
        نوشتن: {
          عدم‌نیاز: false,
          خیلی‌کم: false,
          کم: false,
          تاحدودی: false,
          زیاد: false,
          خیلی‌خوب: false,
        },
        ترجمه: {
          عدم‌نیاز: false,
          خیلی‌کم: false,
          کم: false,
          تاحدودی: false,
          زیاد: false,
          خیلی‌خوب: false,
        },
        مکالمه: {
          عدم‌نیاز: false,
          خیلی‌کم: false,
          کم: false,
          تاحدودی: false,
          زیاد: false,
          خیلی‌خوب: false,
        },
      },
    }
    setZabanKhareji(data);
  }, [selectedLanguage]);

  const taskInputs = Object.keys(zabanKhareji).map((task, index) => (
    <ZabanKhareji
      key={index}
      language={task}
      skills={zabanKhareji[task]}
      setZabanKhareji={setZabanKhareji}
      zabanKhareji={zabanKhareji}
    />
  ));
  /* زبان های خارجی */

  const [maharathayeOmoomi, setMaharathayeOmoomi] = usePersistantState(
    "maharathayeOmoomi",
    {
      "مشتری مداری و تكریم ارباب رجوع": {
        value: {},
        desc: "",
      },
      "ارتباط موثر": {
        value: {},
        desc: "",
      },
      "قدرت بیان و ارتباطات شفاهی": {
        value: {},
        desc: "",
      },
      "اصول و فنون نگارش و مكاتبات": {
        value: {},
        desc: "",
      },
      "اصول و فنون مذاکره": {
        value: {},
        desc: "",
      },
      "مدیریت زمان": {
        value: {},
        desc: "",
      },
      "اصول كار تیمی و مشاركتی": {
        value: {},
        desc: "",
      },
      "تفکر خلاق": {
        value: {},
        desc: "",
      },
      "مدیریت کیفیت نظیر انواع ایزو ها": {
        value: {},
        desc: "",
      },
      "مدلهای تعالی و ارزیابی سازمان": {
        value: {},
        desc: "",
      },
      "مهندسی فکر": {
        value: {},
        desc: "",
      },
      "مدیریت جلسات": {
        value: {},
        desc: "",
      },
      "مدیریت ریسک": {
        value: {},
        desc: "",
      },
      "استاندارد سازی و اصلاح روش ها": {
        value: {},
        desc: "",
      },
      "اصول ایمنی و ارگونومی": {
        value: {},
        desc: "",
      },
      "نظام آراستگی محیط كار": {
        value: {},
        desc: "",
      },
    }
  );

  const [maharathayeModiriati, setMaharathayeModiriati] = usePersistantState(
    "maharathayeModiriati",
    {
      "تصمیم گیری، تشخیص و حل مساله": {
        value: {},
        desc: "",
      },
      "اصول برنامه ریزی": {
        value: {},
        desc: "",
      },
      "اصول كنترل و نظارت": {
        value: {},
        desc: "",
      },
      "مدیریت استراتژیك و ترسیم چشم انداز": {
        value: {},
        desc: "",
      },
      "مدیریت تعارض و تضاد سازمانی": {
        value: {},
        desc: "",
      },
      "اصول رهبری و انگیزش كاركنان": {
        value: {},
        desc: "",
      },
      "مدیریت تغییر و تحول سازمانی": {
        value: {},
        desc: "",
      },
      "اصول مربی گری و هدایت كاركنان": {
        value: {},
        desc: "",
      },
      "پدافند غیرعامل": {
        value: {},
        desc: "",
      },
    }
  );

  const [maharathayeFanavari, setMaharathayeFanavari] = usePersistantState(
    "maharathayeFanavari",
    {
      Word: {
        value: {},
        desc: "",
      },
      Excel: {
        value: {},
        desc: "",
      },
      Access: {
        value: {},
        desc: "",
      },
      PowerPoint: {
        value: {},
        desc: "",
      },
      "امنیت شبكه": {
        value: {},
        desc: "",
      },
      AutoCAD: {
        value: {},
        desc: "",
      },
      "Aspen Hysys": {
        value: {},
        desc: "",
      },
      "Share point": {
        value: {},
        desc: "",
      },
      Photoshop: {
        value: {},
        desc: "",
      },
      Outlook: {
        value: {},
        desc: "",
      },
      SPSS: {
        value: {},
        desc: "",
      },
      COMFAR: {
        value: {},
        desc: "",
      },
      VISIO: {
        value: {},
        desc: "",
      },
      MSP: {
        value: {},
        desc: "",
      },
      Qlikview: {
        value: {},
        desc: "",
      },
      "Power-BI": {
        value: {},
        desc: "",
      },
    }
  );

  const [nezamhayeKeifiat, setNezamhayeKeifiat] = usePersistantState(
    "nezamhayeKeifiat",
    {
      ISO9001: {
        value: {},
        desc: "(ISO 9001 یک استاندارد بین‌المللی مدیریت کیفیت است که به سازمان‌ها کمک می‌کند تا فرآیندهای خود را بهبود داده و بهینه‌سازی کنند.)",
      },
      ISO17799: {
        value: {},
        desc: "ایزو 17799 یک استاندارد مدیریت امنیت اطلاعات شناخته شده است که اولین بار توسط سازمان بین المللی استانداردسازی یا ISO در دسامبر 2000 منتشر شد.",
      },
      ISO14001: {
        value: {},
        desc: "(استاندارد ISO 14001 یک استاندارد بین‌المللی محیط زیست است که به سازمان‌ها کمک می‌کند تا سیستم‌های مدیریت محیط زیست خود را تدوین، پیاده‌سازی، نظارت، و بهبود دهند.)",
      },
      ISO10015: {
        value: {},
        desc: "(استاندارد ISO 10015 یک استاندارد بین‌المللی است که مرتبط با راهنمایی برای توسعه و اجرای برنامه‌های آموزشی در سازمان‌ها است. این استاندارد به سازمان‌ها کمک می‌کند تا فرآیندهای آموزشی خود را بهبود داده و از منابع آموزشی بهینه استفاده کنند.)",
      },
      OHSAS: {
        value: {},
        desc: "(استاندارد OHSAS به معنای 'Occupational Health and Safety Assessment Series' است که به مجموعه‌ای از استانداردهای مدیریت ایمنی و بهداشت شغلی اشاره دارد. این استانداردها برای کمک به سازمان‌ها در ارتقای سطح ایمنی و بهداشت شغلی در محیط کار تهیه شده‌اند.)",
      },
      ISO10002: {
        value: {},
        desc: "(ISO 10002 یک استاندارد بین‌المللی است که به مدیریت شکایات مشتریان می‌پردازد و به سازمان‌ها کمک می‌کند در پاسخ به شکایات مشتریان بهبود ایجاد کنند.)",
      },
      ISO50002: {
        value: {},
        desc: "(استاندارد ISO 50001 یک استاندارد بین‌المللی مرتبط با مدیریت انرژی است که به سازمان‌ها کمک می‌کند تا سیستم‌های مدیریت انرژی خود را بهبود دهند و کارآیی انرژی خود را افزایش دهند.)",
      },
      ISO10012: {
        value: {},
        desc: "(استاندارد ISO 10012 به مدیریت دقت ابزارهای اندازه‌گیری می‌پردازد و بر روی تعیین مشخصات و اعتبارسنجی آنها تمرکز دارد.)",
      },
      ISO31000: {
        value: {},
        desc: "(استاندارد ISO 31000 یک استاندارد بین‌المللی مرتبط با مدیریت ریسک است که به سازمان‌ها کمک می‌کند تا یک فرایند سیستماتیک برای شناسایی، ارزیابی و مدیریت ریسک‌های مختلف خود ایجاد کنند.)",
      },
      ISO34000: {
        value: {},
        desc: "۳۴۰۰۰ ISO، ابزاری برای ارزیابی و آسیب شناسی فرآیندها و نتایج در مدیریت منابع انسانی است. این استاندارد اخیرا به منظور ارزیابی و ارتقای سیستم منابع انسانی مورد استفاده قرار می گیرد.",
      },
      EFQM: {
        value: {},
        desc: "(EFQM یک مدل مدیریت کیفیت جهانی بر پایه اصولی مانند رهبری توجه و تعهد به افراد است که به سازمان‌ها کمک می‌کند تا عملکرد خود را بهبود دهند و در رقابت جهانی بهترین عملکرد را ارائه دهند.)",
      },
      GDP: {
        value: {},
        desc: "(استاندارد GDP یا Good Distribution Practice یک استاندارد بین‌المللی است که الزامات و رویه‌های مربوط به توزیع صحیح و ایمن محصولات دارویی را تعیین می‌کند.)",
      },
    }
  );

  const [ghavaninVaMoghararat, setGhavaninVaMoghararat] = usePersistantState(
    "ghavaninVaMoghararat",
    {
      "قانون كار": {
        value: {},
        desc: "",
      },
      "قانون تجارت": {
        value: {},
        desc: "",
      },
      "قانون مالیات ها": {
        value: {},
        desc: "",
      },
      "حقوق بین الملل": {
        value: {},
        desc: "",
      },
      "حقوق مدنی": {
        value: {},
        desc: "",
      },
      "حقوق گمرك و ترخیص كالا": {
        value: {},
        desc: "",
      },
      "قانون بیمه": {
        value: {},
        desc: "",
      },
      "سیاست های كلی نظام اداری": {
        value: {},
        desc: "",
      },
      "سیاست های اقتصاد مقاومتی": {
        value: {},
        desc: "",
      },
      "سیاست های كلی اشتغال": {
        value: {},
        desc: "",
      },
      "سیاست های كلی پدافند غیرعامل": {
        value: {},
        desc: "",
      },
      "سیاستهای كلی نظام سلامت": {
        value: {},
        desc: "",
      },
      "برنامه های توسعه کشور": {
        value: {},
        desc: "",
      },
      "چشم انداز کشور": {
        value: {},
        desc: "",
      },
      "قانون خدمات کشوری": {
        value: {},
        desc: "",
      },
      "قانون بودجه و ضوابط اجرایی": {
        value: {},
        desc: "",
      },
    }
  );
  return (
    <PanelLayout>
      <Title title="تجزیه و تحلیل شغل" />
      <Progressbar activePart={3} handleStep={handleStep} />
      <div className="bg-white p-10 mx-28 shadow-lg border border-gray-200 rounded-lg">
        {/* <Subheading title="مهارت‌های عمومی مورد نیاز" isFirst={true} />
                <FormCheckbox state={maharathayeOmoomi} setState={setMaharathayeOmoomi} newButtonLabel="افزودن مورد جدید"/>
                <Subheading title="مهارت‌های مدیریتی مورد نیاز" />
                <FormCheckbox state={maharathayeModiriati} setState={setMaharathayeModiriati} newButtonLabel="افزودن مورد جدید"/> */}

        <Subheading title="مهارت زبان‌های خارجی" isFirst={true} />
        <div className="mt-10">
          {taskInputs}
          {/* <button
            onClick={() => setAddTask(true)}
            className="flex w-[250px] justify-center items-center rounded-lg border-2 border-gray-400 placeholder-gray-300 outline-none focus:border-main-color hover:bg-[#5B5CFF] hover:text-white transition duration-300"
          >
          </button> */}
        </div>

        <div>
          <select
            defaultValue={""}
            onChange={(e) => {
              setSelectedLanguage(e.target.value);
            }}
            className="border border-solid bg-white border-gray-400 rounded-md px-5 py-3"
          >
            <option value={""} disabled>
              اضافه کردن زبان
            </option>

            <option value="عربی">عربی</option>
            <option value="فرانسوی">فرانسوی</option>
            <option value="آلمانی">آلمانی</option>
            <option value="چینی">چینی</option>
            <option value="ترکی استانبولی">ترکی استانبولی</option>
            <option value="روسی">روسی</option>
            <option value="پرتقالی">پرتقالی</option>
            <option value="اسپانیایی">اسپانیایی</option>
            <option value="ایتالیایی">ایتالیایی</option>
          </select>
        </div>

        <Subheading title="مهارت‌های فناوری اطلاعات مورد نیاز" />
        <FormCheckbox
          state={maharathayeFanavari}
          setState={setMaharathayeFanavari}
          newButtonLabel="افزودن مورد جدید"
        />

        <Subheading title="استانداردها و نظام‌های کیفیت" />
        <FormCheckbox
          state={nezamhayeKeifiat}
          setState={setNezamhayeKeifiat}
          newButtonLabel="افزودن مورد جدید"
        />

        <Subheading title="قوانین و مقررات" />
        <FormCheckbox
          state={ghavaninVaMoghararat}
          setState={setGhavaninVaMoghararat}
          newButtonLabel="افزودن مورد جدید"
        />

        <div className="flex justify-center items-center relative mt-10 z-50">
          <Button
            isPrevious={true}
            title="مرحله قبل"
            direction="center"
            handleClick={(event) => handleStepDown()}
            color="#f9b302"
          />
          <Button
            title="ثبت اطلاعات و تکمیل فرم بعدی"
            direction="center"
            handleClick={(event) => handleStep()}
          />
        </div>
      </div>
    </PanelLayout>
  );
}
